/* tslint:disable */
/* eslint-disable */
export enum MerchantChangeOrderByEnum {
  Id = 'Id',
  CreatedUtc = 'CreatedUtc'
}
